import { Link } from "react-router-dom";
import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";
import { img, PROJECTS } from "@/lib/site";
// staggered heights for a masonry-like rhythm
const spans = ["md:mt-0", "md:mt-20", "md:mt-0", "md:mt-24", "md:mt-0", "md:mt-16"];

export default function Projects() {
  return (
    <>
      <PageHead
        eyebrow="Our Portfolio"
        titleLines={["Coming", "soon."]}
        intro="Our projects are in progress. Coming soon."
      />
    </>
  );
}
